import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function SaglikAnksiyetesiTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['saglik-anksiyetesi-testi']} />;
}
